export default [
  // {
  //   name: 'terms/privacy',
  //   path: '/terms/privacy',
  //   beforeEnter(to, from, next) {
  //     next()
  //   },
  //   component: require('@/views/terms/PrivacyPolicy.vue').default
  // },
  {
    name: 'terms/service',
    path: '/terms/service',
    component: require('@/views/terms/ServiceTerm.vue').default,
    props: (route) => ({ ...route.params })
  }, {
    name: 'terms/detail',
    path: '/terms/:code',
    component: require('@/views/terms/TermDetail.vue').default,
    beforeEnter(to, from, next) {
      next()
    },
    props: (route) => ({ ...route.params })
  }]
